import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";

const NotificationParser = ({ notification }) => {

    return (
        (() => {
            switch (notification.feature) {
                case "UserNetwork":
                    return (
                        (() => {
                            switch (notification.type) {
                                case 'FollowRequested':
                                    return (
                                        <span>You have a new follower request from <b>{`${notification.subjectUser.firstName} ${notification.subjectUser.surname}`}</b></span>
                                    )
                                case 'FollowApproved':
                                    return (
                                        <span>You are now following <b>{`${notification.subjectUser.firstName} ${notification.subjectUser.surname}`}</b></span>
                                    )
                                case 'NewFollower':
                                    return (
                                        <span><b>{`${notification.subjectUser.firstName} ${notification.subjectUser.surname}`}</b> is now following you.</span>
                                    )
                                case 'Post':
                                    return (
                                        <span><b>{`${notification.subjectUser.firstName} ${notification.subjectUser.surname}`}</b> Posted on their timeline.</span>
                                    )
                                case 'Comment':
                                    return (
                                        <span><b>{`${notification.subjectUser.firstName} ${notification.subjectUser.surname}`}</b> commented on a post on your timeline.</span>
                                    )
                                case 'Reply':
                                    return (
                                        <span><b>{`${notification.subjectUser.firstName} ${notification.subjectUser.surname}`}</b> replied to a comment.</span>
                                    )
                                default:
                                    return null;
                            }
                        })()
                    )
                case 'Groups':
                    return (
                        (() => {
                            switch (notification.type) {
                                case 'Post':
                                    return (
                                        <span><b>{`${notification.subjectUser.firstName} ${notification.subjectUser.surname}`}</b> posted in <b>{notification.parentSubjectTitle}</b></span>
                                    )
                                case 'RequestMembership':
                                    return (
                                        <span><b>{`${notification.subjectUser.firstName} ${notification.subjectUser.surname}`}</b> requested membership to <b>{notification.subjectTitle}</b></span>
                                    )
                                case 'ConfirmMembership':
                                    return (
                                        <span>Your request for membership to <b>{notification.subjectTitle}</b> has been approved!</span>
                                    )
                                case 'AddedToGroup':
                                    return (
                                        <span>You have beed added to the group <b>{notification.subjectTitle}</b></span>
                                    )
                                case 'Share':
                                    return (
                                        <span><b>{`${notification.subjectUser.firstName} ${notification.subjectUser.surname}`}</b> shared the route <b>{notification.subjectTitle}</b> with <b>{notification.parentSubjectTitle}</b></span>
                                    )
                                default:
                                    return null;
                            }
                        })()
                    )
                case 'Events':
                    return (
                        (() => {
                            switch (notification.type) {
                                case 'Create':
                                    return (
                                        <React.Fragment><b>{`${notification.subjectUser.firstName} ${notification.subjectUser.surname}`}</ b> is hosting <b>{notification.subjectTitle}</b> for the <b>{notification.parentSubjectTitle}</b> group</React.Fragment>
                                    )
                                case 'Rsvp':
                                    return (
                                        <span><b>{`${notification.subjectUser.firstName} ${notification.subjectUser.surname}`}</b> responded <b>{notification.message}</b> to <b>{notification.subjectTitle}</b></span>
                                    )
                                case 'Cancel':
                                    return (
                                        <span><b>{`${notification.subjectUser.firstName} ${notification.subjectUser.surname}`}</b> cancelled <b>{notification.subjectTitle}</b></span>
                                    )
                                case 'Delete':
                                    return (
                                        <span><b>{`${notification.subjectUser.firstName} ${notification.subjectUser.surname}`}</b> deleted <b>{notification.subjectTitle}</b></span>
                                    )
                                case 'Post':
                                    return (
                                        <span><b>{`${notification.subjectUser.firstName} ${notification.subjectUser.surname}`}</b> posted in the event <b>{notification.parentSubjectTitle}</b></span>
                                    )
                                default:
                                    return null;
                            }
                        })()
                    )
                case 'Posts':
                    return (
                        (() => {
                            switch (notification.type) {
                                case 'Comment':
                                    return (
                                        <span><b>{`${notification.subjectUser.firstName} ${notification.subjectUser.surname}`}</b> commented on a post in <b>{notification.parentSubjectTitle}</b></span>
                                    )
                                case 'Reply':
                                    return (
                                        <span><b>{`${notification.subjectUser.firstName} ${notification.subjectUser.surname}`}</b> replied to a post that you're following in <b>{notification.parentSubjectTitle}</b></span>
                                    )
                                default:
                                    return null;
                            }
                        })()
                    )
                case 'Routes':
                    return (
                        (() => {
                            switch (notification.type) {
                                case 'Share':
                                    return (
                                        <span><b>{`${notification.subjectUser.firstName} ${notification.subjectUser.surname}`}</b> shared the route <b>{notification.subjectTitle}</b> with <b>{notification.parentSubjectTitle}</b></span>
                                    )
                                case 'Upload':
                                    return (
                                        <span><b>{`${notification.subjectUser.firstName} ${notification.subjectUser.surname}`}</b> uploaded a route: <b>{notification.subjectTitle}</b></span>
                                    )
                                default:
                                    return null;
                            }
                        })()
                    )
                default:
                    return null;
            }
        })() 

    ) 
};

NotificationParser.propTypes = {
    notification: PropTypes.object.isRequired,
}

export default NotificationParser;

//<b>{`${notification.subjectUser.firstName} ${notification.subjectUser.surname}`}</b> responded <b>{notification.message}</b> to <b>{notification.subjectTitle}</b>


// WEBPACK FOOTER //
// ./src/components/user/NotificationParser.js